import React, { FC } from 'react';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Button from 'components/commercetools-ui/atoms/button';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import { useFormat } from 'helpers/hooks/useFormat';
import { ImageProps } from 'frontastic/lib/image';
import { MagnifyingGlassIcon as SearchIcon } from '@heroicons/react/24/solid';
import UtilitySection from '../../../utility-section';
import { useParams } from 'next/navigation'

export interface Props {
  logo: ImageProps;
  logoLink: string;
  categories: Category[];
  onArrowClick: () => void;
  hideHeaderMenu: () => void;
  showSearchBar?: boolean;
  setShowSearchBar?: any;
}

const MobileMenuHeader: FC<Props> = ({
  onArrowClick,
  logo,
  logoLink,
  hideHeaderMenu,
  categories,
  showSearchBar,
  setShowSearchBar,
}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const params = useParams();
  
  return (
    <div className="flex  w-full justify-between border-b border-neutral-400 px-[20.5px] bg-black">
        <HeaderLogo
        logo={logo}
        logoLink={logoLink}
        onClick={hideHeaderMenu}
        imageClassName="flex h-68 text-16 font-bold w-[8.25rem] 2xl:w-[27.125rem]"
      />
      <div className="flex h-full items-center justify-end">
        <div className={`${params.slug==='search' && "hidden"} ml-auto xl:hidden`}>
          <div
            className="ml-auto hover:cursor-pointer lg:hidden xl:pr-24"
            onClick={() => setShowSearchBar(!showSearchBar)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
              <path
                d="M22.75 22.75L16.25 16.25M18.4167 10.8333C18.4167 15.0215 15.0215 18.4167 10.8333 18.4167C6.64517 18.4167 3.25 15.0215 3.25 10.8333C3.25 6.64517 6.64517 3.25 10.8333 3.25C15.0215 3.25 18.4167 6.64517 18.4167 10.8333Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
            </svg>
            {/* <Search categories={categories} /> */}
          </div>
          {/* <Search categories={categories} /> */}
        </div>
        <div className="pr-12 xl:hidden">
          <UtilitySection />
        </div>
        <Button
          variant="ghost"
          size="xs"
          onClick={hideHeaderMenu}
          title={formatMessage({ id: 'close', defaultMessage: 'Close' })}
          className="pr-10"
        >
          <XMarkIcon className="w-24 text-secondary-black stroke-white" />
        </Button>
      </div>
    </div>
  );
};

export default MobileMenuHeader;